// frontend/src/pages/ProjectTaxes.tsx
import type { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import { useProjectFormStore } from "@/store/project-form-provider";
import { ProjectInputField } from "@/components/project-input-field";
import { ProjectSaveButton } from "@/components/project-save-button";
import { ProjectResetButton } from "@/components/project-reset-button";

export default function ProjectTaxes() {
  const { loading, error, formData, updateField, saveAll, resetAll, savingAll, getFieldType, getFieldOptions,
  } = useProjectFormStore();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    updateField(name, value);
  };

  const { t } = useTranslation();

  if (loading) return <div className="p-4 text-xs">{t("common.loading")}</div>;
  if (error || !formData) return <div className="p-4 text-elani text-xs">{t("common.error_loading_data")}</div>;

  return (
    <form className="max-w-md space-y-8 text-xs">
      <div className="space-y-2">
        <div className="text-xs font-bold text-gray-700">{t("project.taxes.depreciation")}</div>
        <ProjectInputField label={t("project.taxes.depreciation_period") + " (" + t("units.years") + ")"} name="depreciation_period" value={formData.depreciation_period} type={getFieldType("depreciation_period")} onChange={handleChange} />
      </div>
      
      <div className="space-y-2">
        <ProjectInputField label={t("project.taxes.iab")} name="investment_deduction_amount_iab" value={formData.investment_deduction_amount_iab} type={getFieldType("investment_deduction_amount_iab")} onChange={handleChange} />
        <ProjectInputField label={t("project.taxes.special_depreciation_year_1")} name="special_depreciation_year_1" value={formData.special_depreciation_year_1} type={getFieldType("special_depreciation_year_1")} onChange={handleChange} />
        <ProjectInputField label={t("project.taxes.special_depreciation_year_2")} name="special_depreciation_year_2" value={formData.special_depreciation_year_2} type={getFieldType("special_depreciation_year_2")} onChange={handleChange} />
        <ProjectInputField label={t("project.taxes.special_depreciation_year_3")} name="special_depreciation_year_3" value={formData.special_depreciation_year_3} type={getFieldType("special_depreciation_year_3")} onChange={handleChange} />
        <ProjectInputField label={t("project.taxes.special_depreciation_year_4")} name="special_depreciation_year_4" value={formData.special_depreciation_year_4} type={getFieldType("special_depreciation_year_4")} onChange={handleChange} />
        <ProjectInputField label={t("project.taxes.special_depreciation_year_5")} name="special_depreciation_year_5" value={formData.special_depreciation_year_5} type={getFieldType("special_depreciation_year_5")} onChange={handleChange} />
      </div>

      <div className="space-y-2">
        <div className="text-xs font-bold text-gray-700">{t("project.taxes.tax_rates")}</div>
        <ProjectInputField label={t("project.taxes.income_tax_rate")} name="tax_rate" value={formData.tax_rate} type={getFieldType("tax_rate")} onChange={handleChange} />
        <ProjectInputField label={t("project.taxes.vat")} name="vat" value={formData.vat} type={getFieldType("vat")} onChange={handleChange} />
      </div>

      <div className="pt-3 flex gap-2">
        <ProjectSaveButton onSave={saveAll} saving={savingAll} />
        <ProjectResetButton onReset={resetAll} saving={savingAll} />
      </div>
    </form>
  );
}